import Search from './src/main.js'
import mixin from './src/mixin'

Search.install = Vue => {
  Vue.component(Search.name, Search)
  mixin(Vue)
}

export default Search
